import styled from "@emotion/styled";

import { Alert } from "metabase/common/components/Alert";

export const ImpersonationAlert = styled(Alert)`
  margin-bottom: 1rem;
`;
